document.addEventListener("DOMContentLoaded", function () {
  const countryFilterSelect = document.getElementById("certificate-filter--countries");
  const categoryFilterSelect = document.getElementById("certificate-filter--categories");
  const typeFilterSelect = document.getElementById("certificate-filter--types");

  if (countryFilterSelect) {
    countryFilterSelect.addEventListener('change', function () {
      updateFilter("country", countryFilterSelect.value.toString());
    });
  }

  if (categoryFilterSelect) {
    categoryFilterSelect.addEventListener('change', function () {
      updateFilter("category", categoryFilterSelect.value.toString());
    });
  }

  if (typeFilterSelect) {
    typeFilterSelect.addEventListener('change', function () {
      updateFilter("type", typeFilterSelect.value.toString());
    });
  }
});

function updateFilter(filterName, filterValue) {
  const pageUrl = window.location.href.replace(location.search, "");
  const urlParams = new URLSearchParams(location.search);

  if (filterValue) {
    urlParams.set(filterName, filterValue);
  } else {
    urlParams.delete(filterName);
  }

  const urlParamString = urlParams.toString();
  if (urlParamString && urlParamString.length > 0) {
    window.location.assign(`${pageUrl}?${urlParams.toString()}`);
  } else {
    window.location.assign(pageUrl);
  }
}